import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { NoCrmAccess, formatDate } from './CrmCustomers';

// Today's date in London, as YYYY-MM-DD, so "overdue" matches the day staff are on.
const londonToday = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/London' }).format(new Date());

const CrmFollowUps = () => {
  const [rows, setRows] = useState([]);
  const [all, setAll] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [noAccess, setNoAccess] = useState(false);

  const load = async (everyone) => {
    setLoading(true);
    try {
      const res = await api.get(`/api/crm/follow-ups${everyone ? '?all=true' : ''}`);
      setRows(res.data);
    } catch (err) {
      if (err.response?.status === 403) setNoAccess(true);
      else setError('Failed to load follow-ups');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(all); }, [all]);

  const markDone = async (id) => {
    try {
      await api.patch(`/api/crm/activities/${id}`, { done: true });
      setRows(prev => prev.filter(r => r.id !== id));
    } catch (err) {
      if (err.response?.status === 403) setNoAccess(true);
      else setError('Failed to update');
    }
  };

  if (noAccess) return <NoCrmAccess />;
  const today = londonToday();

  return (
    <div style={{ maxWidth: '900px' }}>
      <div className="page-header">
        <div>
          <h1 className="page-title">Follow-ups</h1>
          <p className="page-subtitle">Open follow-ups, soonest first</p>
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer' }}>
          <input type="checkbox" checked={all} onChange={e => setAll(e.target.checked)} style={{ accentColor: 'var(--red)' }} />
          Show everyone's
        </label>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      <div className="card">
        {loading ? (
          <div className="loader">Loading...</div>
        ) : rows.length === 0 ? (
          <div className="empty-state">
            <h3>Nothing to follow up</h3>
            <p>Add a follow-up from a customer's timeline</p>
          </div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Due</th>
                  <th>Customer</th>
                  <th>What</th>
                  {all && <th>For</th>}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rows.map(r => (
                  <tr key={r.id}>
                    <td>
                      {r.due_date < today
                        ? <span className="badge badge-declined">{formatDate(r.due_date)}</span>
                        : r.due_date === today
                          ? <span className="badge badge-pending">Today</span>
                          : formatDate(r.due_date)}
                    </td>
                    <td>
                      <Link to={`/crm/customers/${r.customer_id}`} style={{ fontWeight: 500 }}>{r.customer_name}</Link>
                      {r.contact_name && <div style={{ fontSize: '12px', color: 'var(--grey-mid)' }}>{r.contact_name}</div>}
                    </td>
                    <td style={{ whiteSpace: 'pre-wrap' }}>{r.body}</td>
                    {all && <td style={{ color: 'var(--grey-mid)' }}>{r.assigned_to_name || '-'}</td>}
                    <td><button className="btn btn-outline btn-sm" onClick={() => markDone(r.id)}>Done</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default CrmFollowUps;
